import * as util from './util';

export type NodeType = 'input' | 'hidden' | 'output';

class Node {
  number: number;
  type: NodeType;

  private inputSum: number;
  bias: number;

  constructor(number: number, type: NodeType = 'hidden') {
    this.number = number;
    this.bias = util.uniformRandom();

    this.type = type;
    this.inputSum = 0;
  }

  getOutput(): number {
    if (this.type === 'input') return this.inputSum;

    function sigmoid(z: number): number {
      //return z;
      //return Math.max(0, z);
      //return Math.tanh(z);
      return 1 / (1 + Math.exp(-4.9 * z));
    }

    return sigmoid(this.inputSum + this.bias);
  }

  clearInput(): void {
    this.inputSum = 0;
  }

  addInput(input: number, weight: number): void {
    this.inputSum += input * weight;
  }

  //hasPathTo(destination: Node): boolean {
  //  if (this === destination) {
  //    return true;
  //  }

  //  if (this.outputConnections.length === 0) {
  //    return false;
  //  }

  //  return this.outputConnections.some(conn => conn.to.hasPathTo(destination));
  //}

  clone(): Node {
    return new Node(this.number, this.type);
  }
}

export default Node;
